class CoreElement extends HTMLElement {
    constructor() {
        super();
        this.shadow = this.attachShadow({ mode: "open" });
    }

    static get observedAttributes() {
        return [];
    }

    state = { width: 0 };
    setState = (newValue) => {
        this.state = Object.assign(this.state, newValue);
        this.renderHTML();
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        this.renderHTML();
    }

    attr = (attrName) => {
        return this.getAttribute(attrName);
    }

    connectedCallback() {
        setTimeout(() => {
            this.setState({ innerHTML: this.innerHTML });
        }, 1)
        this.renderHTML();
        window.addEventListener('resize', this.onWindowResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    mapStateRender(arr) {
        arr.forEach(({ selector, updateType, fn, value, queryAll }) => {
            const elements = queryAll
                ? this.shadowRoot.querySelectorAll(selector)
                : [this.shadowRoot.querySelector(selector)].filter(Boolean);

            elements.forEach(el => {
                switch (updateType) {
                    case 'class':
                        if (value) el.classList.add(value);
                        else fn(el.classList, el);
                        break;
                    case 'style':
                        fn(el.style, el);
                        break;
                    case 'attr':
                        const getAttr = (attr) => el.getAttribute(attr);
                        const setAttr = (attr, value) => el.setAttribute(attr, value);
                        fn(getAttr, setAttr, el);
                        break;
                    case 'innerHTML':
                        el.innerHTML = value;
                        break;
                    default:
                        if (updateType.includes(".") && value) {
                            const [elKey, nestedKey] = updateType.split('.');
                            if (elKey === 'style') el.style[nestedKey] = value;
                            else if (elKey === 'attr') el.setAttribute(nestedKey, value);
                            else if (elKey === 'prop') el[nestedKey] = value;
                        }
                }
            })

        });
    }
}

if (!window.loadjscssfile) {
    window.loadjscssfile = function (url, filetype, callback) {
        var fileref;
        if (filetype == "js") { //if filename is a external JavaScript file
            fileref = document.createElement('script')
            fileref.setAttribute("type", "text/javascript")
            fileref.setAttribute("src", url)
        } else if (filetype == "css") { //if filename is an external CSS file
            fileref = document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", url)
        }
        // @ts-ignore
        if (typeof fileref != "undefined") document.getElementsByTagName("head")[0].appendChild(fileref)
        fileref.addEventListener('load', callback);
    }
}

if (!window.waitUntilJQueryLoaded) {
    window.waitUntilJQueryLoaded = function (callback) {
        let jCount = 0;
        let interval = setInterval(function () {
            if (!!window.jQuery) {
                clearInterval(interval);
                callback(window.jQuery);
            } else {
                jCount++;
                if (jCount >= 7) {
                    clearInterval(interval);
                    loadjscssfile('https://code.jquery.com/jquery-3.7.1.min.js', 'js', () => {
                        callback(window.jQuery);
                    });
                }
            }
        }, 300);
    }
}
